import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgEigenAIIcon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    width="298"
    height="324"
    viewBox="0 0 298 324"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <polygon
      fill="currentColor"
      points="35,25 35,284 229,284 229,220 165,220 164,219 164,155 165,154 229,154 229,90 230,89 261,89 261,25 230,25 230,89 229,90 197,90 196,89 196,25 134,25 134,56 164,56 165,57 165,154 164,155 133,155 133,219 132,220 100,220 99,219 99,25"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgEigenAIIcon);
export default ForwardRef;
